import { Box, Button, Checkbox, Container, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography } from "@mui/material"
import styleCss from "../Style/style"
import PercentageIcon from "../img/percentage-icon.png"
import { Link, useNavigate } from "react-router-dom"
import NewGift from "../img/new-gift-icon.png"
import Round1 from "../img/blue-round-icon.png"
import Round2 from "../img/green-round-icon.png"
import { decryptData } from "../Utilities/crypto"
import { useEffect, useState } from "react"
import { AuthAxios } from "../Utilities/CommonAxios"
import showToast from "../Utilities/showToast"
import { useFormik } from "formik"
import * as Yup from "yup";
import dayjs from "dayjs"

const CompleteYourPayment = () => {
    const [fareSummary, setFareSummary] = useState('')
    const [paymentMode, setPaymentMode] = useState([])
    const [trackDetails, setTrackDetails] = useState('')
    let _d = (decryptData(localStorage.getItem('_d')))
    const navigate = useNavigate()
    _d = JSON.parse(_d)
    const gstCalculation = async () => {
        try {
            const apiResponse = await AuthAxios(({
                url: '/seat_gst_calculation',
                method: 'post',
                payload: {
                    seat_price: _d.passenger_details.map(p => p.basic_fare).join(',')
                }
            }))
            if (apiResponse?.status) {
                setFareSummary(apiResponse?.data)
            } else {
                showToast('error', apiResponse?.message)
            }
        } catch (error) {
            showToast('error', error?.message)
        }
    }

    const getPaymentMethod = async () => {
        try {
            const apiResponse = await AuthAxios(({
                url: '/get_payment_modes',
                method: 'post',
                payload: {}
            }))
            if (apiResponse.status) {
                setPaymentMode(apiResponse?.data)
            } else {
                showToast('error', apiResponse?.message)
            }
        } catch (error) {
            showToast('error', error?.message)
        }
    }

    const getTrackDetails = async () => {
        try {
            const apiResponse = await AuthAxios(({
                url: '/bus_trip_details',
                method: 'post',
                payload: {
                    schedule_id: _d?.track_id
                }
            }))
            if (apiResponse?.status) {
                setTrackDetails(apiResponse?.data[0])
            } else {
                showToast('error', apiResponse?.message)
            }
        } catch (error) {
            showToast('error', error.message)

        }
    }


    useEffect(() => {
        gstCalculation()
        getPaymentMethod()
        getTrackDetails()
    }, [])


    const paymentFormik = useFormik(({
        initialValues: {
            payment_mode: "",
            term_policy: false
        },
        validationSchema: Yup.object(({
            payment_mode: Yup.string().required("kindly select the payment mode"),
            term_policy: Yup.boolean()
                .oneOf([true], "You must accept the terms and conditions")
                .required(),
        })),
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: async (values) => {
            try {
                _d["booking_date"] = dayjs().format("YYYY-MM-DD HH:MM:ss");

                const apiResponse = await AuthAxios({
                    url: "/bus_booking",
                    method: "post",
                    payload: _d,
                });
                console.log(apiResponse)
                if (apiResponse?.status === 422) throw new Error(apiResponse?.data?.message)
                if (apiResponse?.status) {
                    showToast("success", "Your booking confirmed");
                    navigate("/my-account");
                } else {
                    showToast("error", "Your booking not confirmed");
                }
            } catch (error) {
                showToast("error", error?.message);
            }
        }
    }))



    return (
        <>
            <Grid sx={styleCss.CommonTopStyle}>
                <Container>
                    <form onSubmit={paymentFormik.handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid size={{ md: 8, xs: 12 }}>
                                <Box sx={{
                                    padding: '20px',
                                    borderRadius: '10px',
                                    backgroundColor: '#fff',
                                    marginBottom: '20px',
                                }}>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: '20px',
                                        fontWeight: 600,
                                        textAlign: 'left',
                                        color: '#1d1d1d',
                                    }}>
                                        Complete Your Payment
                                    </Typography>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: '15px',
                                        fontWeight: 'normal',
                                        textAlign: 'left',
                                        color: '#364252',
                                    }}>
                                        Secure payments gateway with 256-bit encryption
                                    </Typography>
                                    <Box sx={{
                                        padding: '15px',
                                        borderRadius: '10px',
                                        backgroundColor: '#fefbe9',
                                        marginTop: '15px',
                                        border: 'solid 1px #ffe28a',
                                    }}>
                                        <Typography sx={{
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '17px',
                                            fontWeight: 600,
                                            textAlign: 'left',
                                            color: '#1d1d1d',
                                        }}>
                                            <img src={PercentageIcon} alt="" style={{ verticalAlign: 'middle', marginRight: '10px' }} /> Have a Coupon code
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box sx={{
                                    padding: '20px',
                                    borderRadius: '10px',
                                    backgroundColor: '#fff',
                                    marginBottom: '20px',
                                }}>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: '20px',
                                        fontWeight: 600,
                                        textAlign: 'left',
                                        color: '#1d1d1d',
                                    }}>
                                        Choose Payment Method
                                    </Typography>
                                </Box>
                                <Box sx={{
                                    padding: '20px',
                                    borderRadius: '10px',
                                    backgroundColor: '#fff',
                                    marginBottom: '20px',
                                }}>


                                    <FormControl sx={{ width: "100%" }}>
                                        <RadioGroup
                                            name="payment_mode"
                                            value={paymentFormik?.values?.payment_mode || null}
                                            onChange={(e) => paymentFormik.setFieldValue('payment_mode', Number(e.target.value))}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 1.5,
                                            }}
                                        >
                                            {paymentMode &&
                                                paymentMode.map((method, i) => (
                                                    <FormControlLabel
                                                        key={i}
                                                        value={method?.payment_mode_id || i}
                                                        control={
                                                            <Radio
                                                                sx={{
                                                                    color: "#1d3557",
                                                                    "&.Mui-checked": { color: "#1d3557" },
                                                                    padding: "0px 0px 0px 10px",
                                                                }}
                                                            />
                                                        }
                                                        label={
                                                            <Typography
                                                                component="span"
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "3px",
                                                                    fontFamily: '"Segoe UI", sans-serif',
                                                                    fontSize: "13px",
                                                                    fontWeight: "normal",
                                                                    color: "#030213",
                                                                    whiteSpace: "nowrap",
                                                                    cursor: "pointer",
                                                                    marginLeft: "5px",
                                                                }}
                                                            >
                                                                {method?.payment_desc}
                                                            </Typography>
                                                        }
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            fontFamily: "Segoe UI",
                                                        }}
                                                    />
                                                ))}
                                        </RadioGroup>
                                    </FormControl>
                                    {paymentFormik.touched.payment_mode && paymentFormik.errors.payment_mode && (
                                        <Typography
                                            sx={{
                                                color: "red",
                                                fontSize: "12px",
                                                mt: 1,
                                                ml: 5,
                                                fontFamily: '"Segoe UI", sans-serif',
                                            }}
                                        >
                                            {paymentFormik.errors.payment_mode}
                                        </Typography>
                                    )}

                                </Box>
                                <Box sx={{
                                    padding: '20px',
                                    borderRadius: '10px',
                                    backgroundColor: '#fff',
                                    marginBottom: '20px',
                                }}>
                                    <FormControlLabel
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            fontFamily: "Segoe UI",
                                        }}
                                        control={
                                            <Checkbox

                                                name="term_policy"
                                                checked={paymentFormik?.values.term_policy}
                                                onChange={(e) => paymentFormik?.setFieldValue("term_policy", e.target.checked)}
                                                sx={{
                                                    color: "#1d3557",
                                                    "&.Mui-checked": { color: "#1d3557" },
                                                    padding: "0px 0px 0px 10px",
                                                }}
                                            />
                                        }
                                        label={
                                            <Typography
                                                component="span"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "3px",
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: "13px",
                                                    fontWeight: "normal",
                                                    color: "#030213",
                                                    whiteSpace: "nowrap",
                                                    cursor: "pointer",
                                                    marginLeft: '5px',
                                                }}
                                            >
                                                I agree to the
                                                <Link
                                                    href="#"
                                                    underline="none"
                                                    style={{ color: "#0027d9", fontWeight: 500, fontSize: "13px", fontFamily: '"Segoe UI", sans-serif', textDecoration: 'unset' }}
                                                >
                                                    Terms & Conditions
                                                </Link>
                                                and
                                                <Link
                                                    href="#"
                                                    underline="none"
                                                    style={{ color: "#0027d9", fontWeight: 500, fontSize: "13px", fontFamily: '"Segoe UI", sans-serif', textDecoration: 'unset' }}
                                                >
                                                    Privacy Policy
                                                </Link>
                                            </Typography>

                                        }

                                    />
                                    {paymentFormik.touched.term_policy && paymentFormik.errors.term_policy && (
                                        <Typography
                                            sx={{
                                                color: "red",
                                                fontSize: "12px",
                                                mt: 1,
                                                ml: 5, // indent error under checkbox
                                                fontFamily: '"Segoe UI", sans-serif',
                                            }}
                                        >
                                            {paymentFormik.errors.term_policy}
                                        </Typography>
                                    )}

                                    <Box sx={{
                                        padding: '17px 25px',
                                        borderRadius: '15px',
                                        backgroundColor: '#f3f3f3',
                                        marginTop: '20px',
                                    }}>
                                        <Typography sx={{
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            fontStretch: 'normal',
                                            fontStyle: 'normal',
                                            lineHeight: 'normal',
                                            letterSpacing: 'normal',
                                            textAlign: 'left',
                                            color: '#0e182b',
                                            marginBottom: '10px',
                                        }}>
                                            Cancellation Policy
                                        </Typography>
                                        <Typography sx={{
                                            fontFamily: 'Segoe UI',
                                            fontSize: '12px',
                                            fontWeight: 'normal',
                                            textAlign: 'left',
                                            color: '#0e182b',
                                            marginBottom: '5px',
                                        }}>
                                            Cancellation charges: 10% up to 2 hours before departure
                                        </Typography>
                                        <Typography sx={{
                                            fontFamily: 'Segoe UI',
                                            fontSize: '12px',
                                            fontWeight: 'normal',
                                            textAlign: 'left',
                                            color: '#0e182b',
                                            marginBottom: '5px',
                                        }}>
                                            No refund within 2 hours of departure
                                        </Typography>
                                        <Typography sx={{
                                            fontFamily: 'Segoe UI',
                                            fontSize: '12px',
                                            fontWeight: 'normal',
                                            textAlign: 'left',
                                            color: '#0e182b',
                                            marginBottom: '5px',
                                        }}>
                                            Refunds processed within 5-7 working days
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Box sx={{
                                    marginBottom: '15px',
                                    padding: '10px',
                                    borderRadius: '10px',
                                    boxShadow: '0 4px 100px 0 rgba(0, 0, 0, 0.05)',
                                    backgroundImage: 'linear-gradient(110deg, #00bc80 15%, #00c85b 101%)',
                                }}>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: '17px',
                                        fontWeight: 600,
                                        textAlign: 'left',
                                        color: '#fff',
                                    }}>
                                        <img alt="" src={NewGift} style={{ verticalAlign: 'middle', marginRight: '3px' }} /> Exclusive deal applied
                                    </Typography>
                                </Box>
                                <Box sx={{
                                    padding: '20px',
                                    borderRadius: '10px',
                                    backgroundColor: '#fff',
                                    marginBottom: '20px',
                                }}>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: '17px',
                                        fontWeight: 600,
                                        textAlign: 'left',
                                        color: '#0e182b',
                                    }}>
                                        Booking Details
                                    </Typography>
                                    <Box sx={{ borderBottom: '1px solid #ddd', width: '100%', marginBottom: '10px', marginTop: '10px' }}>
                                    </Box>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: '20px',
                                        fontWeight: 600,
                                        textAlign: 'left',
                                        color: '#0e182b',
                                        marginBottom: '10px',
                                    }}>
                                        {trackDetails?.bus_name}
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid size={{ md: 6, xs: 12 }}>
                                            <Typography sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                                textAlign: 'left',
                                                color: '#364252',
                                            }}>{trackDetails?.seat_layout_name}</Typography>
                                        </Grid>
                                        <Grid size={{ md: 6, xs: 12 }}>
                                            <Typography sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                                textAlign: 'left',
                                                color: '#364252',
                                            }}>Seat No:

                                                <span style={{
                                                    padding: '3px 8px',
                                                    borderRadius: '7px',
                                                    backgroundColor: '#c3e1ff',
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '15px',
                                                    fontWeight: 600,
                                                    textAlign: 'center',
                                                    color: '#0e182b',
                                                }}>L16</span> </Typography>

                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                                        <Grid size={{ md: 1, xs: 2 }}>
                                            <img alt="" src={Round1} style={{ verticalAlign: 'middle' }} />
                                        </Grid>
                                        <Grid size={{ md: 11, xs: 10 }}>
                                            <Typography sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '17px',
                                                fontWeight: 600,
                                                fontStretch: 'normal',
                                                fontStyle: 'normal',
                                                lineHeight: 'normal',
                                                letterSpacing: '0.34px',
                                                textAlign: 'left',
                                                color: '#0e182b',
                                            }}>
                                                {trackDetails?.arrival_time ?? "22:30"} <span style={{
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '12px',
                                                    fontWeight: 'normal',
                                                    fontStretch: 'normal',
                                                    fontStyle: 'normal',
                                                    lineHeight: 'normal',
                                                    letterSpacing: 'normal',
                                                    textAlign: 'left',
                                                    color: '#364252',
                                                }}>{dayjs(_d?.travel_date).format("MMM DD")}</span>
                                            </Typography>
                                            <Typography sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '17px',
                                                fontWeight: 600,
                                                letterSpacing: '0.34px',
                                                textAlign: 'left',
                                                color: '#364252',
                                                marginTop: '5px',
                                            }}>
                                                {trackDetails?.origin_name}.
                                            </Typography>
                                            <Typography sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '12px',
                                                fontWeight: 'normal',
                                                textAlign: 'left',
                                                color: '#1b89ff',
                                            }}>
                                                Boarding point
                                            </Typography>
                                            <Grid sx={{
                                                border: '1px dotted  #e5e5e5',
                                                height: '40px',
                                                width: '0px',
                                                marginTop: '10px',
                                            }}></Grid>
                                        </Grid>

                                        <Grid size={{ md: 1, xs: 2 }}>
                                            <img alt="" src={Round2} style={{ verticalAlign: 'middle' }} />
                                        </Grid>
                                        <Grid size={{ md: 11, xs: 10 }}>
                                            <Typography sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '17px',
                                                fontWeight: 600,
                                                fontStretch: 'normal',
                                                fontStyle: 'normal',
                                                lineHeight: 'normal',
                                                letterSpacing: '0.34px',
                                                textAlign: 'left',
                                                color: '#0e182b',
                                            }}>
                                                {trackDetails?.departure_time ?? "06:30"} <span style={{
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '12px',
                                                    fontWeight: 'normal',
                                                    fontStretch: 'normal',
                                                    fontStyle: 'normal',
                                                    lineHeight: 'normal',
                                                    letterSpacing: 'normal',
                                                    textAlign: 'left',
                                                    color: '#364252',
                                                }}>{dayjs(_d?.travel_date).format("MMM DD")}</span>
                                            </Typography>
                                            <Typography sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '17px',
                                                fontWeight: 600,
                                                letterSpacing: '0.34px',
                                                textAlign: 'left',
                                                color: '#364252',
                                                marginTop: '5px',
                                            }}>
                                                {/* Koyambedu, chennai. */}
                                                {trackDetails?.destination_name}
                                            </Typography>
                                            <Typography sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '12px',
                                                fontWeight: 'normal',
                                                textAlign: 'left',
                                                color: '#4ead68',
                                            }}>
                                                Arrival
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Box sx={{ borderBottom: '1px solid #ddd', width: '100%', marginBottom: '15px', marginTop: '15px' }}>
                                    </Box>
                                    <Box sx={{
                                        padding: '20px 15px',
                                        borderRadius: '10px',
                                        backgroundColor: ' #f3fbff',
                                        marginBottom: '20px',
                                    }}>
                                        <Typography sx={{
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '17px',
                                            fontWeight: 600,
                                            textAlign: 'left',
                                            color: '#0e182b',
                                            marginBottom: '10px',
                                        }}>
                                            Fare Breakdown
                                        </Typography>
                                        <Grid container spacing={2}>
                                            <Grid size={{ md: 9, xs: 8 }}>
                                                <Typography sx={{
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '14px',
                                                    fontWeight: 'normal',
                                                    textAlign: 'left',
                                                    color: '#364252',
                                                    marginBottom: '5px',
                                                }}>Base (2 Seats)</Typography>
                                                <Typography sx={{
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '14px',
                                                    fontWeight: 'normal',
                                                    textAlign: 'left',
                                                    color: '#364252',
                                                    marginBottom: '5px',
                                                }}>Booking Fee</Typography>
                                                <Typography sx={{
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '14px',
                                                    fontWeight: 'normal',
                                                    textAlign: 'left',
                                                    color: '#364252',
                                                    marginBottom: '5px',
                                                }}>GST (5%)</Typography>
                                                {/* <Typography sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '14px',
                                                fontWeight: 'normal',
                                                textAlign: 'left',
                                                color: '#4ead68',
                                                marginBottom: '5px',
                                            }}>Discount</Typography> */}
                                            </Grid>
                                            <Grid size={{ md: 3, xs: 4 }}>
                                                <Typography sx={{
                                                    fontFamily: 'Segoe UI',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    textAlign: 'right',
                                                    color: '#030213',
                                                    marginBottom: '5px',
                                                }}>
                                                    ₹{fareSummary?.total_price}
                                                </Typography>
                                                <Typography sx={{
                                                    fontFamily: 'Segoe UI',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    textAlign: 'right',
                                                    color: '#030213',
                                                    marginBottom: '5px',
                                                }}>
                                                    ₹{fareSummary?.total_price}
                                                </Typography>
                                                <Typography sx={{
                                                    fontFamily: 'Segoe UI',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    textAlign: 'right',
                                                    color: '#030213',
                                                    marginBottom: '5px',
                                                }}>
                                                    ₹{fareSummary?.total_gst}
                                                </Typography>
                                                {/* <Typography sx={{
                                                fontFamily: 'Segoe UI',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                textAlign: 'right',
                                                color: '#4ead68',
                                                marginBottom: '5px',
                                            }}>
                                                - ₹50
                                            </Typography> */}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Grid container spacing={2}>
                                        <Grid size={{ md: 12, xs: 12 }}>
                                            <Box sx={{
                                                padding: '15px 14px',
                                                borderRadius: '10px',
                                                backgroundColor: '#fffaeb',
                                            }}>
                                                <Typography sx={{
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '14px',
                                                    fontWeight: 'bold',
                                                    fontStretch: 'normal',
                                                    fontStyle: 'normal',
                                                    lineHeight: 'normal',
                                                    letterSpacing: '0.28px',
                                                    textAlign: 'left',
                                                    color: '#973904',
                                                }}>
                                                    Your ticket will be sent to
                                                </Typography>
                                                <Typography sx={{
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '12px',
                                                    fontWeight: 'normal',
                                                    textAlign: 'left',
                                                    color: '#973904',
                                                }}>
                                                    {_d?.passenger_contact_number}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Box sx={{ borderBottom: '1px solid #ddd', width: '100%', marginBottom: '15px', marginTop: '15px' }}>
                                    </Box>
                                    <Box sx={{
                                        display: 'flex', alignItems: 'center', padding: '10px 10px',
                                        borderRadius: '5px',
                                        backgroundImage: 'linear-gradient(to right, #fff7ed, #fefbe9)',
                                        marginBottom: '15px',
                                    }}>
                                        <Grid sx={{ ml: 1 }}>
                                            <Typography sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                                textAlign: 'left',
                                                color: '#364252',
                                                fontWeight: 'bold',
                                            }}>Total</Typography>
                                        </Grid>
                                        <Grid sx={{ marginLeft: 'auto' }}>
                                            <Typography sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '14px',
                                                fontWeight: 'bold',
                                                color: '#0027d9',
                                            }}>₹{fareSummary?.total_amount}</Typography>
                                        </Grid>
                                    </Box>
                                    <Button type="submit" variant="contained" sx={{
                                        padding: '7px 13px',
                                        borderRadius: '7px',
                                        backgroundColor: '#ff5714',
                                        fontFamily: 'SegoeUI',
                                        fontSize: '15px',
                                        fontWeight: '500',
                                        textAlign: 'center',
                                        color: '#fff',
                                        fontFamily: '"Segoe UI", sans-serif',
                                        textTransform: 'capitalize',
                                        width: '100%',
                                        marginTop: '5px',
                                        marginBottom: '15px',
                                        "@media (max-width:600px)": {
                                            marginTop: '15px',
                                        },
                                    }}>Pay</Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </Container>
            </Grid>
        </>
    )
}
export default CompleteYourPayment